import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Roles } from '@shared/models/types';
import { UserFilterURL, UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class PartnerService extends UserService {
  constructor(activatedRoute: ActivatedRoute) {
    super(activatedRoute);
  }

  override set filters(value: UserFilterURL) {
    const partnerFilters = { ...value, role: Roles.PARTNER };
    super.filters = partnerFilters;
  }

  initializePartners() {
    this.filters = { role: Roles.PARTNER };
  }
}
